const Divider = () => {
  return <div className="my-1 -mx-4 md:-mx-5  col-span-1 md:col-span-2 h-4 shadow-md ">&nbsp;</div>;
};

export default Divider;
